import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


/* This view is used make bootstrap checkboxes work like normal checkboxes. */

export default Backbone.View.extend({
  events: {
    click: 'toggle'
  },

  initialize: function () {
    _.bindAll(this, 'toggle', 'checked', 'check', 'uncheck');

    this.$el.data('checkbox_view', this);
    var name = this.$el.data('name');
    this.input = $('input[name="' + name + '"]', this.$el.parent());
  },

  toggle: function (e) {
    e.preventDefault();
    if (this.checked()) {
      this.uncheck();
    } else {
      this.check();
    }
  },

  checked: function () {
    return this.$el.is('.setting-enabled');
  },

  check: function () {
    this.$el.addClass('setting-enabled');
    if (this.input.length) {
      this.input.prop('checked', true);
    }
    this.trigger('checked', this);

    // Uncheck other options if this is a radio
    if (this.input.attr('type') == 'radio') {
      var radios = $('.check[data-name=' + this.$el.data('name') + ']');
      _.each(radios.not(this.$el), function (other_radio) {
        $(other_radio).data('checkbox_view').uncheck();
      });
    }
  },

  uncheck: function () {
    this.$el.removeClass('setting-enabled');
    if (this.input.length) {
      this.input.prop('checked', false);
    }
    this.trigger('unchecked', this);
  },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/views/checkbox.js
// module id = 23
// module chunks = 0